import {useSelector} from 'react-redux';

import {selectAllBadges} from '@/state/selectors/loyalty';
import MultiLevelBadgeDetails from '@/views/MultiLevelBadgeDetails/MultiLevelBadgeDetails';
import JourneyLevelBadgeDetails from '@/views/JourneyLevelBadgeDetails/JourneyLevelBadgeDetails';
import SingleLevelBadgeDetails from '@/views/SingleLevelBadgeDetails/SingleLevelBadgeDetails';

type BadgeDetailSlideProps = {
    badgeId: string;
    levelBadgeId: string | null;
    titleId?: string;
};

const BadgeDetailSlide = ({badgeId, levelBadgeId, titleId}: BadgeDetailSlideProps) => {
    const badge = useSelector(selectAllBadges).find((b) => b.id === badgeId || b.journeyId === badgeId) ?? null;

    if (!badge) return null;

    if (badge.isSingleLevel) {
        return <SingleLevelBadgeDetails badge={badge} titleId={titleId} />;
    }

    if (levelBadgeId) {
        return <JourneyLevelBadgeDetails journeyBadge={badge} levelBadgeId={levelBadgeId} />;
    }

    return <MultiLevelBadgeDetails badge={badge} titleId={titleId} />;
};

export default BadgeDetailSlide;
